import script from "./ModalCreate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalCreate.vue?vue&type=script&lang=ts&setup=true"

import "./ModalCreate.vue?vue&type=style&index=0&id=6b304864&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b304864"]])

export default __exports__